import { PROJECT_PARTICIPANT_SCHEDULED_STATUSES } from 'lib/generated_constants/projects';

export default function isScheduledStatus(status) {
  return !!PROJECT_PARTICIPANT_SCHEDULED_STATUSES.find(
    (stat) => stat === status,
  );
}
